import { connect } from 'react-redux';

import { assign as _assign } from 'lodash';

import {
  ChangeEmailModel,
  CreateFormProps,
  GlobalState,
  formatMessage
}
  from 'src/api';

import {
  createForm, 
  FormValues
} from 'src/api/models/Form/Form';

import {
  changeEmailFormValues,
} from 'src/api/models/ChangeEmail/change-email.class';

import { 
  requestAPIActions,RequestApiHttpPayload, 
  removeAccessTokenFromCookie, 
  clearAuthentification
} from 'loopback-react-request';

import './ChangeEmailForm.scss';

import MESSAGES from './ChangeEmailForm.messages';
import { appSettings } from 'src/config';

const changeEmailFormProperty = createForm<ChangeEmailModel, CreateFormProps<ChangeEmailModel>>({
  afterSubmitSuccess: (dispatch, state) => {
    removeAccessTokenFromCookie(appSettings.cookieName);
    dispatch(clearAuthentification());
  },
  className: 'partial-login-form my-0 mx-auto',
  dispatchData: (dispatch, values) => dispatch(requestAPIActions.load<RequestApiHttpPayload>('changeEmail', {
    url: '/Users/request-change-email',
    options: {
      method: 'POST',
      data: values,
    },
  })),
  formFields: changeEmailFormValues(),
  preSubmit: (values: FormValues<ChangeEmailModel>, state: GlobalState | undefined) => {
    let userData = state && state.userData && state.userData.result;
    if (userData) {
      _assign (values, {id: userData.userId});
    }
    return values
  },
  redirectTo: '/change-email/succeeded',
  shouldRedirect: true,
  stateKeys: 'changeEmail',
  submitButton: {
    text: formatMessage({...MESSAGES.changeEmailFormButton}),
    className: 'changeEmail-button mt-3 w-100 mb-3'
  }
})();


export const ChangeEmailForm = connect((state: GlobalState) => ({state}))(changeEmailFormProperty);